module.exports = __webpack_public_path__ + "static/media/vitalJoin2.7f42977c.png";